import SearchIcon from "@mui/icons-material/Search"
import { FormControlLabel, Grid, IconButton, InputBase, Switch, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../theme"
import { BimModelOrganisationImportCounterCard } from "../../../../../../components/BimModelOrganisationImportCounterCard"

type IProps = {
  hideLinkedBimModel: boolean
  setHideLinkedBimModel: React.Dispatch<React.SetStateAction<boolean>>
  searchValue: string
  setSearchValue: React.Dispatch<React.SetStateAction<string>>
}

export function BSBimModelSearchHeader({
  hideLinkedBimModel,
  setHideLinkedBimModel,
  searchValue,
  setSearchValue,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <Grid container alignItems="center" pt={1}>
      <Grid item xs={5} display="flex" alignItems="center" borderRadius={3} py={1} sx={{}}>
        <InputBase
          sx={{ pl: 1, backgroundColor: customPalette.white, flex: 1, borderRadius: 3 }}
          value={searchValue}
          placeholder="Rechercher par nom"
          inputProps={{ "aria-label": "search" }}
          endAdornment={
            <IconButton type="submit">
              <SearchIcon sx={{ margin: "0 8px" }} />
            </IconButton>
          }
          onChange={(e: { target: { value: any } }) => {
            setSearchValue(e.target.value)
          }}
        />
      </Grid>
      <Grid item xs={4} px={2}>
        <FormControlLabel
          control={<Switch name="Masquer les maquettes non liées" color="primary" />}
          value={hideLinkedBimModel}
          onChange={() => setHideLinkedBimModel(!hideLinkedBimModel)}
          label={
            <Typography fontSize={12} fontWeight={500} sx={{ color: customPalette.subtitleGray }}>
              Masquer les maquettes non liées
            </Typography>
          }
        />
      </Grid>

      <Grid item xs={3} display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
        <BimModelOrganisationImportCounterCard />
      </Grid>
    </Grid>
  )
}
